import moment from 'moment';

const MisteryReportAdapter = (data) => {
  if (!data) {
    return [];
  }

  const newArr = [];

  const prepareData = (i) => ({
    ...i,
    'companies.title': i?.company?.title,
    'shopping_centers.title': i?.company?.shopping_center?.title,
    file_date: moment(i?.file_date, 'YYYY-MM-DD').format('DD MMMM YYYY'),
  });

  if (Array.isArray(data)) {
    data.forEach((i) => {
      newArr.push(prepareData(i));
    });

    return newArr;
  }

  return prepareData(data);
};

export default MisteryReportAdapter;
